module.exports = __webpack_public_path__ + "img/20190802131937954.1f668da5.png";